import { hasPlaceholder, IMAGE_PLACEHOLDERS, } from '@wix/shoutout-email-model-v3';
import { getFileExtension } from './get-file-extension';
export var isGif = function (src) { return /\.gif/.test(src); };
export var endsInFileKeyword = function (src) { return /file$/.test(src); };
export var isYoutubeThumbnail = function (src) {
    return /youtube/.test(src) || /i\.ytimg/.test(src);
};
export var getImageWidth = function (region, maxContentWidth) {
    var naturalWidth = region.data.width ? region.data.width : maxContentWidth;
    var imageWidth = naturalWidth >= maxContentWidth ? maxContentWidth : naturalWidth;
    return imageWidth;
};
var MIX_IMAGE_WIDTH = 700;
export var getImageSrc = function (_a) {
    var region = _a.region, fallbackUrl = _a.fallbackUrl, maxContentWidth = _a.maxContentWidth, _b = _a.isMix, isMix = _b === void 0 ? false : _b, _c = _a.replaceImagePlaceholders, replaceImagePlaceholders = _c === void 0 ? false : _c;
    var relativeUri = region.data.relativeUri;
    var src = relativeUri
        ? 'https://static.wixstatic.com/media/' + relativeUri
        : region.data.url || fallbackUrl;
    if (replaceImagePlaceholders && hasPlaceholder(src)) {
        relativeUri = '';
        if (region.data.placeholderPreviewType === 'avatar') {
            src = IMAGE_PLACEHOLDERS.AVATAR;
        }
        else if (isMix) {
            src = IMAGE_PLACEHOLDERS.GENERIC_IN_COLUMN;
        }
        else {
            src = IMAGE_PLACEHOLDERS.GENERIC;
        }
    }
    return [
        {
            condition: supportsVangoghQuery(src) &&
                !isGif(src) &&
                !hasVangoghQuery(src) &&
                !isYoutubeThumbnail(src) &&
                !endsInFileKeyword(src),
            transform: function () {
                if (isMix) {
                    return getImageUrl(src, MIX_IMAGE_WIDTH, relativeUri);
                }
                return getNormalImageSrcWidthExactWidth(src, region, maxContentWidth, relativeUri);
            },
        },
        {
            condition: supportsVangoghQuery(src) &&
                !isGif(src) &&
                !endsInFileKeyword(src) &&
                hasVangoghQuery(src),
            transform: function () {
                var croppedSrc = getCroppedImageSrcWidthExactWidth(src, region, maxContentWidth);
                return getFittedImageSrcWidthExactWidth(croppedSrc, region, maxContentWidth, isMix);
            },
        },
        {
            condition: true,
            transform: function () { return src; },
        },
    ].reduce(function (result, matcher) {
        if (!result && matcher.condition) {
            return matcher.transform();
        }
        return result;
    }, '');
};
function getNormalImageSrcWidthExactWidth(src, region, maxContentWidth, relativeUri) {
    if (relativeUri === void 0) { relativeUri = null; }
    var imageWidth = getImageWidth(region, maxContentWidth);
    return getImageUrl(src, imageWidth, relativeUri);
}
function getCroppedImageSrcWidthExactWidth(src, region, maxContentWidth) {
    var imageWidth = getImageWidth(region, maxContentWidth);
    return replaceCroppedImagesWidth(src, imageWidth);
}
function getFittedImageSrcWidthExactWidth(src, region, maxContentWidth, useMixWidth) {
    var imageWidth = useMixWidth
        ? MIX_IMAGE_WIDTH
        : getImageWidth(region, maxContentWidth);
    return src.split('fit').reduce(function (url, urlPart, index) {
        if (index === 1) {
            var updatedWidth = urlPart.replace(/(w_\d+)/, "w_" + imageWidth);
            return url + "fit" + updatedWidth;
        }
        return "" + url + urlPart;
    }, '');
}
function supportsVangoghQuery(src) {
    var supports = src.match(/static\.(wixstatic|wix)\.com\/media\/.*/);
    return supports;
}
function hasVangoghQuery(src) {
    return src.match(/\/v1\/.*/);
}
function getImageUrl(src, imageWidth, relativeUri) {
    if (relativeUri === void 0) { relativeUri = null; }
    // NOTE: Make sure that ImageWithLoader from composer still works if you change this.
    var imageUrlBase = src + "/v1/fit/w_" + imageWidth + ",h_2000,al_c,q_85/";
    if (relativeUri) {
        return "" + imageUrlBase + relativeUri;
    }
    var extension = getFileExtension({ src: src });
    return imageUrlBase + "image." + extension;
}
function replaceCroppedImagesWidth(src, width) {
    return src.split('crop').reduce(function (url, urlPart, index) {
        if (index === 1) {
            var updatedWidth = urlPart.replace(/(w_\d+)/, "w_" + width);
            return url + "crop" + updatedWidth;
        }
        return "" + url + urlPart;
    }, '');
}
//# sourceMappingURL=image-utils.js.map